var initialExperimentBackendStatus = {
  loading: false,
  error: false,
  status: null,
  // What each of the experiment's workers is doing right now, keyed by WorkerGpuType.
  // At most two entries: each work queue is FIFO with a single message group, so a worker
  // runs one task at a time. Unlike `status`, this isn't polled from the API - it's fed by
  // worker heartbeats over the socket, so it survives a backend status reload.
  workerStatus: {},
  // Which worker each task runs on, keyed by task name. Filled in from the API's answer to
  // a work request and never removed because for a given experiment the API always routes a task
  // to the same worker.
  // This is following the same logic as with the ETag,
  // where the UI has the info to generate it but instead defers to the api
  taskWorkers: {}
};
var initialState = {};
export default initialState;
export { initialExperimentBackendStatus };